import { render, staticRenderFns } from "./NumberCounterJsTwo.vue?vue&type=template&id=a3180862&"
import script from "./NumberCounterJsTwo.vue?vue&type=script&lang=js&"
export * from "./NumberCounterJsTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports